<template>
  <div
    :class="[
      'flex items-start gap-[1.44rem] rounded-lg border-l-[0.25rem] bg-white-500 py-4 pl-4 pr-7 text-neutral-950 shadow-card',
      targetConfig.barClass,
    ]"
    :data-test="'ToastToastBase-' + targetConfig.dataTestType"
  >
    <div class="flex grow items-center justify-start gap-4">
      <TIcon
        :name="targetConfig.icon"
        :height="32"
        :width="32"
        :class="[targetConfig.iconClass]"
      />
      <p v-if="props.type === 'loading'" class="grow text-sm">
        {{ props.header ?? props.description }}
      </p>
      <div v-else class="grow">
        <p :class="['text-sm_1 font-bold']">
          {{ props.header ?? targetConfig.header }}
        </p>
        <span class="text-sm font-normal">
          {{ props.description }}
        </span>
      </div>
    </div>
    <button
      v-if="!(props.type === 'loading' || props.hideCloseButton)"
      @click="$emit('close-toast')"
    >
      <Close :height="20" :width="20" class="text-neutral-500" />
    </button>
  </div>
</template>

<script setup lang="ts">
import Close from '~/assets/images/icons/close.svg?component';
import { $t } from '~/plugins/i18n';

interface ToastConfigType {
  [key: string]: {
    icon: 'circular_cancel' | 'circular_info' | 'check_circle' | 'loader';
    barClass: string;
    iconClass: string;
    header?: string;
    dataTestType?: string;
  };
}

const toastConfig: ToastConfigType = {
  info: {
    icon: 'circular_info',
    barClass: 'border-primary-500',
    iconClass: 'text-primary-500 shrink-0',
    header: $t('info'),
    dataTestType: 'Info',
  },
  error: {
    icon: 'circular_cancel',
    barClass: 'border-danger-500',
    iconClass: 'text-danger-500 shrink-0',
    header: $t('error'),
    dataTestType: 'Error',
  },
  success: {
    icon: 'check_circle',
    barClass: 'border-success-500',
    iconClass: 'text-success-500 shrink-0',
    header: $t('success'),
    dataTestType: 'Success',
  },
  loading: {
    icon: 'loader',
    barClass: 'border-white-500',
    iconClass: 'text-primary-500 animate-spin shrink-0',
    dataTestType: 'Loading',
  },
};

const props = defineProps({
  type: { type: String, required: true, default: null },
  description: { type: String, required: true },
  header: { type: String, required: false },
  hideCloseButton: { type: Boolean, required: false },
});

const targetConfig = toastConfig[props.type];
</script>

<style></style>
